<template>
  <TransferRates />
</template>
<script>
import TransferRates from "@/components/master/transferTariff/TransferRates.vue";
export default {
  components: {
    TransferRates,
  },
  updated() {
    this.$helper.collapseMenu("selling-tariff");
    this.$helper.setNavigationClass("selling-transfer-link-new");
  },
};
</script>


// WEBPACK FOOTER //
// src/components/master/sellingTariff/TransferRateList.vue